export default "__VITE_ASSET__CtNdeXNZ__"